import { Routes } from '@angular/router';
import { clientSessionGuard } from './core/guards/client-session.guard';
import { legalAcceptanceGuard } from './core/guards/legal-acceptance.guard';
import { tenantGuard } from './core/guards/tenant.guard';

export const routes: Routes = [
  {
    path: 'invalid-link',
    loadComponent: () => import('./ui/pages/invalid-link/invalid-link.component').then((m) => m.InvalidLinkComponent),
  },
  {
    path: 'embed/workflow/:workflowId',
    loadComponent: () => import('./ui/pages/embed-host/embed-host.component').then((m) => m.EmbedHostComponent),
  },
  {
    path: '',
    canActivateChild: [tenantGuard],
    children: [
      {
        path: 'login',
        loadComponent: () => import('./ui/pages/login/login.component').then((m) => m.LoginComponent),
      },
      {
        path: 'otp',
        loadComponent: () => import('./ui/pages/otp/otp.component').then((m) => m.OtpComponent),
      },
      {
        path: 'start',
        loadComponent: () =>
          import('./ui/pages/generic-link-start/generic-link-start.component').then((m) => m.GenericLinkStartComponent),
      },
      {
        path: 'access',
        loadComponent: () =>
          import('./ui/pages/notification-access/notification-access.component').then((m) => m.NotificationAccessComponent),
      },
      {
        path: 'legal-acceptance',
        canActivate: [clientSessionGuard],
        loadComponent: () => import('./ui/pages/legal-acceptance/legal-acceptance.component').then((m) => m.LegalAcceptanceComponent),
      },
      {
        path: 'inbox',
        canActivate: [clientSessionGuard, legalAcceptanceGuard],
        loadComponent: () => import('./ui/pages/inbox/inbox.component').then((m) => m.InboxComponent),
      },
      {
        path: 'activities/:fileNumber/:activityId',
        canActivate: [clientSessionGuard, legalAcceptanceGuard],
        loadComponent: () => import('./ui/pages/activities/activities.component').then((m) => m.ActivitiesComponent),
      },
      {
        path: 'status/:fileNumber',
        canActivate: [clientSessionGuard, legalAcceptanceGuard],
        loadComponent: () => import('./ui/pages/request-status/request-status.component').then((m) => m.RequestStatusComponent),
      },
      {
        path: 'resolution/:fileNumber',
        canActivate: [clientSessionGuard, legalAcceptanceGuard],
        loadComponent: () => import('./ui/pages/resolution/resolution.component').then((m) => m.ResolutionComponent),
      },
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      // Enlaces Tipo A repartidos con el path anterior. El backend ya emite
      // `start` y sigue aceptando el legado al reenviar, pero el que ya está en
      // manos de un cliente apunta acá: sin este redirect cae en not-found.
      { path: 'iniciar', redirectTo: 'start' },
      {
        path: '**',
        loadComponent: () => import('./ui/pages/not-found/not-found.component').then((m) => m.NotFoundComponent),
      },
    ],
  },
];
